import env from "../config/env";

const VERSION_KEY = "cwpos_app_version";
const SCHEMA_VERSION_KEY = "cwpos_schema_version";

// Bump this when localStorage data shape changes (independent of app version)
const CURRENT_SCHEMA_VERSION = 1;

const AUTH_PRESERVE_KEYS = [
  "authTokens",
  "oAuthData",
  "refreshToken",
  "tillValue",
  "username",
];

export function checkAppVersionGate() {
  try {
    const storedVersion = localStorage.getItem(VERSION_KEY);
    const currentVersion = env.releaseNo;

    if (!storedVersion) {
      localStorage.setItem(VERSION_KEY, currentVersion);
      return false;
    }

    if (storedVersion !== currentVersion) {
      clearStaleData(currentVersion);
      return true;
    }

    return false;
  } catch {
    return false;
  }
}

export function checkSchemaVersionGate() {
  try {
    const stored = parseInt(localStorage.getItem(SCHEMA_VERSION_KEY), 10);
    if (stored === CURRENT_SCHEMA_VERSION) return false;

    clearStaleData(env.releaseNo);
    return true;
  } catch {
    return false;
  }
}

function clearStaleData(newVersion) {
  const preserved = {};
  AUTH_PRESERVE_KEYS.forEach((key) => {
    const val = localStorage.getItem(key);
    if (val) preserved[key] = val;
  });

  // Preserve auth cookies too (they're in document.cookie, not localStorage)
  const keysToRemove = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (!AUTH_PRESERVE_KEYS.includes(key)) {
      keysToRemove.push(key);
    }
  }
  keysToRemove.forEach((key) => localStorage.removeItem(key));

  Object.entries(preserved).forEach(([key, val]) => {
    localStorage.setItem(key, val);
  });

  localStorage.setItem(VERSION_KEY, newVersion);
  localStorage.setItem(SCHEMA_VERSION_KEY, String(CURRENT_SCHEMA_VERSION));
}

export function stampCurrentVersion() {
  localStorage.setItem(VERSION_KEY, env.releaseNo);
  localStorage.setItem(SCHEMA_VERSION_KEY, String(CURRENT_SCHEMA_VERSION));
}
